import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap/dist/css/bootstrap.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-free/css/all.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-free/css/v4-shims.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@yaireo/tagify/dist/tagify.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-datetime/css/react-datetime.css");
;
import(/* webpackMode: "eager" */ "/app/packages/components/assets/flaticon/flaticon.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/rc-menu/assets/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-grid-layout/css/styles.css");
;
import(/* webpackMode: "eager" */ "/app/packages/components/assets/images/placeholders/placeholder-video.png");
;
import(/* webpackMode: "eager", webpackExports: ["StoreContext"] */ "/app/packages/components/stores/StoreContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/style.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/fonts.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/_reset.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/_organization.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/_notification-styles.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/_floating-blocks-theme.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/cropperjs/dist/cropper.css");
;
import(/* webpackMode: "eager" */ "/app/packages/components/styles/_variables.module.scss");
